// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const AmplifyUrl = URL;
const AmplifyUrlSearchParams = URLSearchParams;

export { AmplifyUrl, AmplifyUrlSearchParams };
//# sourceMappingURL=index.mjs.map
